import { Home } from "./components/Home";
import Stats from "./components/Stats";
import { Error } from "./components/Error/Error";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
     path: '/stats',
     element: <Stats />
  },
  {
     path: '/error',
     element: <Error />
  }

];

export default AppRoutes;
